import {
    getFirestore,
    collection,
    getDocs,
    updateDoc,
    doc,
    getDoc,
    Timestamp,
    deleteDoc,
    addDoc,
} from "firebase/firestore";
import { ErrorHelper } from "../helpers/ErrorHelper";
import { FireHelper } from "../helpers/FireHelper";
import { Firebase } from "../FirebaseApp";
import { toast } from "react-toastify";

export const TaxController = {
    db: getFirestore(Firebase),

    ToFirestoreBoatType: function (data) {
        let updatedData = {
            id: data.id,
            name: data.name,
            value: data.value,
            created_time: data.created_time ?? Timestamp.now(),
            updated_time: Timestamp.now(),
        };
        return FireHelper.ToFirestoreDoc(updatedData);
    },

    Insert: async function (data, res) {
        try {
          const inviteRef = collection(this.db, "taxes");
          const result = await addDoc(inviteRef, this.ToFirestoreBoatType(data));
    
          res(result.id);
        } catch (e) {
          toast(ErrorHelper.HandleMessage(e));
        }
      },

    Update: async function (data, res) {
        try {
            const frankDocRef = doc(this.db, "taxes", data.id);
            await updateDoc(frankDocRef, this.ToFirestoreBoatType(data));
        } catch (e) {
            toast(ErrorHelper.HandleMessage(e));
        }
    },

    List: async function (res) {
        const querySnapshot = await getDocs(
            collection(this.db, "taxes")
        );
        const results = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        res(results);
    },
    
  Delete: async function (id) {
    await deleteDoc(doc(this.db, "taxes", id));
    return true;
  },
};
